export class PrinterPayload {
  event: string;
  data: string;
  constructor(event:string, data: string) {
    this.event = event;
    this.data = data;
  }
}
